export const LLM_PROVIDER = {
    AZURE_OPENAI: 'AZURE_OPENAI',
    GEMINI: 'GEMINI',
    ANTHROPIC: 'ANTHROPIC',
    SNOWFLAKE: 'SNOWFLAKE',
    CUSTOM: 'CUSTOM',
};
export const PROVIDER_CONFIG = {
    [LLM_PROVIDER.AZURE_OPENAI]: {
        id: LLM_PROVIDER.AZURE_OPENAI,
        imageUrl: '/node_modules/@thoughtspot/radiant-styles/public/img/azure-logo.svg',
    },
    [LLM_PROVIDER.GEMINI]: {
        id: LLM_PROVIDER.GEMINI,
        imageUrl: '/node_modules/@thoughtspot/radiant-styles/public/img/google-logo.svg',
    },
    [LLM_PROVIDER.ANTHROPIC]: {
        id: LLM_PROVIDER.ANTHROPIC,
        imageUrl: '/node_modules/@thoughtspot/radiant-styles/public/img/anthropic-logo.png',
    },
    [LLM_PROVIDER.SNOWFLAKE]: {
        id: LLM_PROVIDER.SNOWFLAKE,
        imageUrl: '/node_modules/@thoughtspot/radiant-styles/public/img/snowflake-logo.svg',
    },
    [LLM_PROVIDER.CUSTOM]: {
        id: LLM_PROVIDER.CUSTOM,
        imageUrl: '/node_modules/@thoughtspot/radiant-styles/public/img/custom-llm-provider.svg',
    },
};
//# sourceMappingURL=llm-gateway-constants.js.map